import { Box } from '@wix/design-system';
import React, { useContext, useMemo, useState } from 'react';
import { ModalContext, EditorContext } from 'ricos-context';
import { Link_Target } from 'ricos-schema';
import { FloatingLayout, LinkSettings, FooterActions } from 'wix-rich-content-ui-components';
import { linkPreviewModals } from '../consts.js';
import { LINK_PREVIEW_TYPE } from '../types.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const SettingsModal = ({ nodeId }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const modalService = useContext(ModalContext) || {};
  const { getEditorCommands } = useContext(EditorContext);
  const initialData = useMemo(
    () => getEditorCommands().getBlockComponentData(nodeId),
    []
  );
  const [componentData, setComponentData] = useState(initialData);
  const updateData = (data) => {
    getEditorCommands().setBlock(nodeId, LINK_PREVIEW_TYPE, __spreadValues(__spreadValues({}, componentData), data));
    setComponentData(__spreadValues(__spreadValues({}, componentData), data));
  };
  const closeModal = () => {
    modalService.closeModal(linkPreviewModals.settings);
  };
  const handleOnCancel = () => {
    updateData(initialData);
    closeModal();
  };
  return componentData ? /* @__PURE__ */ React.createElement(
    FloatingLayout,
    {
      onCloseButtonClick: handleOnCancel,
      content: {
        children: /* @__PURE__ */ React.createElement(Box, { padding: "SP4" }, /* @__PURE__ */ React.createElement(
          LinkSettings,
          {
            linkValue: {
              url: (_a = componentData.link) == null ? void 0 : _a.url,
              openInNewTab: ((_b = componentData.link) == null ? void 0 : _b.target) === Link_Target.BLANK,
              nofollow: (_d = (_c = componentData.link) == null ? void 0 : _c.rel) == null ? void 0 : _d.nofollow,
              noreferrer: (_f = (_e = componentData.link) == null ? void 0 : _e.rel) == null ? void 0 : _f.noreferrer,
              sponsored: (_h = (_g = componentData.link) == null ? void 0 : _g.rel) == null ? void 0 : _h.sponsored
            },
            options: {
              showInputField: false,
              showNewTabCheckbox: true,
              showNoReferrerCheckbox: true,
              showNoFollowCheckbox: true,
              showSponsoredCheckbox: true
            },
            onChange: (data) => {
              setComponentData((prev) => {
                var _a2, _b2;
                const rel = data.nofollow || data.noreferrer || data.sponsored ? {
                  nofollow: getValueOrDefault(data.nofollow),
                  noreferrer: getValueOrDefault(data.noreferrer),
                  sponsored: getValueOrDefault(data.sponsored)
                } : void 0;
                return __spreadProps(__spreadValues({}, prev), {
                  link: __spreadProps(__spreadValues({}, prev.link), {
                    url: (_a2 = prev.link) == null ? void 0 : _a2.url,
                    anchor: (_b2 = prev.link) == null ? void 0 : _b2.anchor,
                    target: data.openInNewTab ? Link_Target.BLANK : Link_Target.TOP,
                    rel
                  })
                });
              });
            }
          }
        ))
      },
      footer: {
        children: /* @__PURE__ */ React.createElement(
          FooterActions,
          {
            onSave: () => {
              updateData(componentData);
              closeModal();
            },
            onCancel: handleOnCancel
          }
        )
      }
    }
  ) : null;
};
const getValueOrDefault = (value) => value ? value : void 0;

export { SettingsModal };
//# sourceMappingURL=SettingsModal.js.map
